import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-center fs-4 fw-bold" }, "Missing required information", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-center mt-5" }, " It is required to register stores before proceed. ", -1)
const _hoisted_3 = { class: "mt-5 d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn btn-primary px-5",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToPropertiesPage && _ctx.goToPropertiesPage(...args)))
      }, " Go to store registration ")
    ])
  ], 64))
}